module.exports = __webpack_public_path__ + "media/images/ride_requests/car_loading-5cd37ec0d993a69f6f7d9aac1a699d1a.gif";